module.exports = __webpack_public_path__ + "img/bff034d626dd5c1ff324420dbecac029.png";